import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';

import { ClockIcon } from '@/shared/components/Icons';

import moment from 'moment';

import momentDurationFormatSetup from 'moment-duration-format';
import DataCacheService from '@/shared/services/DataCacheService';
import messages from '../taskMessages';
import TaskIcon from '../TaskIcon';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';

momentDurationFormatSetup(moment);

const formatDurationToTime = duration =>
  moment.duration(duration, 'minutes').format('hh:mm', {
    trim: false,
  });

const TaskDetailRegistrations = ({ task, intl, historyActive, onShowHistory, registrations }) => {
  const formattedDuration = moment.duration(task.duration, 'minutes').format('hh:mm', {
    trim: false,
  });

  const hasCostRegistrations =
    registrations && registrations.filter(x => x.resource.type === 1).length > 0;
  const hasTimeRegistrations =
    registrations && registrations.filter(x => x.resource.type === 0).length > 0;

  const showTaskLevelIcon = task.taskLevel === 0;

  const getTaskLevelForRegistration = registration => {
    if (registration.plannedTaskId === task.id) return task.taskLevel;
    const child = (task.children || []).find(c => c.id === registration.plannedTaskId);
    return child ? child.taskLevel : undefined;
  };

  return (
    <div className="task-detail-section registration">
      {!historyActive && (!task.children || task.children.length === 0) && (
        <a className="btn btn-default btn-xs pull-right show-history-btn" onClick={onShowHistory}>
          <i className="fa fa-history margin5R" />
          <span>{intl.formatMessage(messages.ShowHistory)}</span>
        </a>
      )}
      <h5 className="visible-lg-inline-block">
        <ClockIcon className="clock-icon margin5R" />
        {hasTimeRegistrations &&
          !hasCostRegistrations &&
          intl.formatMessage(messages.CountRegistrationsForDuration, {
            count: registrations.length,
            duration: formattedDuration,
          })}
        {hasCostRegistrations &&
          intl.formatMessage(messages.CountRegistrations, {
            count: registrations.length,
          })}
        {!hasCostRegistrations &&
          !hasTimeRegistrations &&
          intl.formatMessage(messages.NoRegistrationsForThisTask)}
      </h5>

      {(hasCostRegistrations || hasTimeRegistrations) && (
        <table>
          <thead>
            <tr>
              {showTaskLevelIcon && <th />}
              <th>
                <FormattedMessage {...messages.Date} />
              </th>
              <th>
                <FormattedMessage {...messages.PriceListItem} />
              </th>

              <th>
                <FormattedMessage {...messages.Employee} />
              </th>
              <th>
                <FormattedMessage {...messages.From} />
              </th>
              <th>
                <FormattedMessage {...messages.To} />
              </th>
              <th>
                <FormattedMessage {...messages.Quantity} />
              </th>
            </tr>
          </thead>
          <tbody>
            {registrations.slice(0, 10).map(registration => {
              const username = DataCacheService.getUserName(registration.userId);
              return (
                <tr key={registration.id}>
                  {showTaskLevelIcon && (
                    <td>
                      <TaskIcon taskLevel={getTaskLevelForRegistration(registration)} />
                    </td>
                  )}
                  <td>
                    <FormattedDateShort value={registration.date} />
                  </td>
                  <td>
                    {registration.resource &&
                      intl.formatMessage(
                        listItemMsg(
                          'resource',
                          registration.resource.id,
                          registration.resource.name,
                        ),
                      )}
                  </td>

                  <td>{username}</td>
                  <td>
                    {registration.resource.type === 0 &&
                      formatDurationToTime(registration.fromMinutes)}
                  </td>
                  <td>
                    {registration.resource.type === 0 &&
                      formatDurationToTime(registration.toMinutes)}
                  </td>
                  <td>
                    {registration.resource.type === 0 &&
                      formatDurationToTime(registration.durationMinutes)}
                    {registration.resource.type === 1 && registration.quantity}
                  </td>
                </tr>
              );
            })}
            {registrations.length > 10 && (
              <tr>
                <td>...</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

TaskDetailRegistrations.propTypes = {
  task: PropTypes.shape({
    relation: PropTypes.object,
    id: PropTypes.string,
  }).isRequired,
  registrations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TaskDetailRegistrations);
